import { ImageUpload } from "@/schema/latest";
import { fold, Success } from "@indietabletop/appkit";
import { client } from "../client";
import { toKnownFailureMessage } from "../hooks/use-form";
import { SelectedArmyImage, StagedImageUpload } from "./MainImageDialog";

export async function uploadStagedImages<T extends SelectedArmyImage>(
  images: (T | null | undefined)[],
) {
  return fold(
    await Promise.all(
      images
        .filter((i) => !!i)
        .map(async (image) => {
          if (image.type === "STAGED") {
            const remoteSrcOp = await client.uploadImage(image.file);
            return remoteSrcOp
              .mapSuccess((src): ImageUpload => {
                return { type: "IMAGE_UPLOAD", src };
              })
              .mapFailure((failure) => {
                if (failure.type === "API_ERROR" && failure.code === 401) {
                  return `Failed to upload image. You must be logged in to upload images.`;
                }

                return toKnownFailureMessage(failure);
              });
          }

          return new Success(image as Exclude<T, StagedImageUpload>);
        }),
    ),
  );
}
